module.exports = "/assets/412fcee7f0f72279f910db2a4cecfbd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/D3.png
// module id = 1287
// module chunks = 0